// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"de2914f0","769":"2250d304"}[chunkId] + ".chunk.js";
};